module.exports = __webpack_public_path__ + "img/x6.54ced676.png";